<div
  [ngClass]="styleClass || ['px-3', 'pt-1', 'pb-2']"
  [appAlertStyle]="severity">
  <app-header *ngIf="header" [icon]="severityIcon" [text]="header"></app-header>

  <div *ngIf="text" [innerHTML]="text"></div>

  <div [ngClass]="{ hidden: !contentWrapper.childNodes.length }">
    <div
      *ngIf="canToggle"
      class="cursor-pointer flex gap-3 pt-3"
      (click)="toggleCollapsed()">
      <u>{{ toggleLabel }}</u>
      <i
        class="ml-auto"
        [ngClass]="
          collapsed ? 'fas fa-chevron-circle-down' : 'fas fa-chevron-circle-up'
        "></i>
    </div>

    <div
      [@detailContentState]="!collapsed || !canToggle ? 'visible' : 'hidden'">
      <div #contentWrapper>
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
